import React from 'react';

import './NotFound.scss';

const NotFound = () => (
		<div data-testid="pnot-found" className="not-found">
			<section className="not-found">
            	<h1>PAGE NOT FOUND</h1>
			</section>
		</div>
    );

export default NotFound;